export default {
	"0775b92d58a5c7ab6552436c162ba136": "商品詳情頁_更多優惠券點擊",
	"a5a1b35089fae034b3bdf78b9a303e00": "更多優惠券"
}
